import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IFilesConfigurationService = ( createDecorator('filesConfigurationService'));
export { IFilesConfigurationService };
